import { TimePickerProps } from '@mui/lab'
import { TextFieldProps } from '@mui/material'
import { TimePicker } from '@mui/x-date-pickers'
import { Controller, useFormContext } from 'react-hook-form'
import { useTranslation } from 'react-i18next'

import { TIME_FORMATS } from 'app/lib/constants'

export type TimePickerFormFieldProps = Omit<
  TimePickerProps<any>,
  'onChange' | 'value' | 'renderInput'
> &
  Pick<TextFieldProps, 'helperText'> & {
    name: string
    required?: boolean
    variant?: 'filled' | 'outlined' | 'standard'
    hideLabel?: boolean
    size?: 'small' | 'medium'
  }

const TimePickerFormField = ({
  name,
  required,
  helperText,
  ...props
}: TimePickerFormFieldProps) => {
  const { t } = useTranslation()
  const { control } = useFormContext()
  const { variant, size, openTo, ...timePickerProps } = props

  if (props.hideLabel) {
    timePickerProps.label = null
  }

  return (
    <Controller
      control={control}
      name={name}
      render={({ field, fieldState: { error } }) => (
        <TimePicker
          format={TIME_FORMATS.INVITATION_TIME}
          openTo={openTo}
          views={['hours']}
          slotProps={{
            textField: {
              variant: variant || 'standard',
              fullWidth: true,
              size,
              required,
              name,
              error: !!error?.message,
              helperText: error?.message
                ? t(error.message, '', { label: props.label })
                : helperText,
              inputProps: {
                'data-testid': `timepicker-${name}`,
                sx: variant === 'outlined' && {
                  padding: '8.5px 14px',
                },
              },
            },
          }}
          {...field}
          {...timePickerProps}
        />
      )}
    />
  )
}

export default TimePickerFormField
